module.exports = __webpack_public_path__ + "img/adriano.3e5a4336.png";